export default function () {
    return {
        counter() {
            const wishlist = this.$store.mageCacheStorage.data.wishlist;

            if (wishlist) {
                const counter = wishlist.counter || '';

                return counter.split(' ')[0] || 0;
            }

            return 0;
        }
    };
}
